<template>
  <div class="title-box">
    <h2 class="title-box_title">Featured in exhibition</h2>
    <div class="title-box_right">
      <div class="title-box_right-content">
        <Tag
          class="tag--public"
          :class="{ 'tag--selected': cardData.key === i.id }"
          v-for="i in tagsData"
          :key="i.id"
          :value="i.title"
          @click="$emit('changeSort', i.id)"
        />
      </div>
      <div class="divider divider--vertical"></div>
      <div class="title-box_right-content">
        <PublicSelect
          v-if="cardData.key === 'art'"
          style="min-width: 190px"
          :items="sortDataArts"
          :selected="cardData.sort"
          @input="$emit('sortExhibition', $event)"
        />
        <PublicSelect
          v-else
          style="min-width: 190px"
          :items="sortDataArtists"
          :selected="cardData.sort"
          @input="$emit('sortExhibition', $event)"
        />
        <FilterBlock
          style="margin-left: 15px"
          :items="filters"
          :search="search"
          @open="$emit('update:openFilters', $event)"
          @selectFilter="$emit('selectFilter', $event)"
          @apply="$emit('applyFilters')"
          @clear="$emit('clearFilters')"
          @changeSearch="$emit('changeSearch', $event)"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ExhibitionHeader",
  props: {
    tagsData: {
      type: Array,
      required: true,
    },
    sortDataArts: {
      type: Array,
      required: true,
    },
    sortDataArtists: {
      type: Array,
      required: true,
    },
    filters: {
      type: Array,
      required: true,
    },
    search: {
      type: String,
      required: true,
    },
    cardData: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.title-box {
  @include titleFlexWrapper;

  &_right {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    &-content {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      align-items: center;

      & > * {
        margin-bottom: 10px;
      }
    }
    @media screen and (max-width: $lg) {
      margin-top: 30px;
      margin-left: -10px;
    }
    @media screen and (max-width: $xs) {
      width: 100%;
      flex-direction: column;
      justify-content: flex-end;
      .divider {
        display: none;
      }
      &-content {
        flex-wrap: wrap;
        &:last-of-type {
          margin-left: 15px;
        }
      }
    }
  }
  &_title {
    font-size: 5.2rem;
    line-height: 1.25;
    @media screen and (max-width: $md) {
      font-size: 35px;
    }
  }
}
</style>

